// ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Desplazarse hacia el top cuando la ubicación cambie
    window.scrollTo(0, 0);
  }, [location]);

  return null; // Este componente no renderiza nada visual
};

export default ScrollToTop;
